import {
  collection, doc, setDoc, deleteDoc, updateDoc,
  getDocs, query, where, onSnapshot
} from 'firebase/firestore';
import { db } from '../firebase';

const COL = 'smm_users';

// Real-time listener — admin panel uchun
export const onUsersChange = (callback) => {
  return onSnapshot(collection(db, COL), (snapshot) => {
    const users = snapshot.docs.map(d => ({ id: d.id, ...d.data() }));
    callback(users, null);
  }, (err) => {
    callback([], err);
  });
};

// Yangi foydalanuvchi qo'shish
export const addUserToFirestore = async (user) => {
  const { id, ...data } = user;
  await setDoc(doc(db, COL, id), data);
};

// Foydalanuvchini o'chirish
export const deleteUserFromFirestore = async (userId) => {
  await deleteDoc(doc(db, COL, userId));
};

// Parolni yangilash
export const updateUserPassword = async (userId, newPassword) => {
  await updateDoc(doc(db, COL, userId), { password: newPassword });
};

// Profil ma'lumotlarini yangilash (ism, email)
export const updateUserProfile = async (userId, data) => {
  await updateDoc(doc(db, COL, userId), data);
};

// Login uchun — email bo'yicha qidirish
export const findUserByEmail = async (email) => {
  const q = query(collection(db, COL), where('email', '==', email.toLowerCase()));
  const snapshot = await getDocs(q);
  if (snapshot.empty) return null;
  const d = snapshot.docs[0];
  return { id: d.id, ...d.data() };
};
